/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The BagusageUpdateBagUsageParam model module.
 * @module model/BagusageUpdateBagUsageParam
 * @version 1.0
 */
class BagusageUpdateBagUsageParam {
    /**
     * Constructs a new <code>BagusageUpdateBagUsageParam</code>.
     * @alias module:model/BagusageUpdateBagUsageParam
     */
    constructor() { 
        
        BagusageUpdateBagUsageParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BagusageUpdateBagUsageParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BagusageUpdateBagUsageParam} obj Optional instance to populate.
     * @return {module:model/BagusageUpdateBagUsageParam} The populated <code>BagusageUpdateBagUsageParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BagusageUpdateBagUsageParam();

            if (data.hasOwnProperty('bagType')) {
                obj['bagType'] = ApiClient.convertToType(data['bagType'], 'String');
            }
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('quantity')) {
                obj['quantity'] = ApiClient.convertToType(data['quantity'], 'Number');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} bagType
 */
BagusageUpdateBagUsageParam.prototype['bagType'] = undefined;

/**
 * @member {String} date
 */
BagusageUpdateBagUsageParam.prototype['date'] = undefined;

/**
 * @member {Number} id
 */
BagusageUpdateBagUsageParam.prototype['id'] = undefined;

/**
 * @member {Number} quantity
 */
BagusageUpdateBagUsageParam.prototype['quantity'] = undefined;

/**
 * @member {Number} userId
 */
BagusageUpdateBagUsageParam.prototype['userId'] = undefined;






export default BagusageUpdateBagUsageParam;

